import { baseApi } from "./baseApi";

const countyLoanLimitApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountyLoanLimit: builder.query({
      query: ({ fipsCode, programType, year }) => {
        const params = new URLSearchParams();
        if (programType) params.set('programType', programType);
        if (year) params.set('year', year);
        const qs = params.toString();
        return {
          url: `/county-loan-limits/${fipsCode}${qs ? `?${qs}` : ''}`,
          method: "GET",
        };
      },
      providesTags: ["CountyLoanLimits"],
    }),
    getCountiesByState: builder.query({
      query: ({ stateCode, year }) => {
        const params = new URLSearchParams();
        if (year) params.set('year', year);
        const qs = params.toString();
        return {
          url: `/county-loan-limits/counties/${stateCode}${qs ? `?${qs}` : ''}`,
          method: "GET",
        };
      },
      providesTags: (result, error, { stateCode }) => [
        { type: "CountyLoanLimits", id: `counties-${stateCode}` },
      ],
    }),
  }),
});

export const { useLazyGetCountyLoanLimitQuery, useGetCountiesByStateQuery } = countyLoanLimitApi;
export default countyLoanLimitApi;
